import React from "react";
import { Info, BarChart3, Trophy, ShieldAlert, CheckCircle2 } from "lucide-react";
import { lotteries } from "../mock";

export default function InfoSections() {
  const items = [
    {
      icon: Info,
      title: "¿Cómo Funcionan las Predicciones?",
      text: "Las predicciones publicadas se basan en el análisis de estadísticas, patrones históricos y tendencias numéricas. Aunque ayudan a identificar números con mayor presencia, no garantizan resultados, ya que cada sorteo es independiente y está sujeto al azar.",
    },
    {
      icon: BarChart3,
      title: "Probabilidades de los Números",
      text: "Cuando se trata de probabilidades y juegos de azar, el éxito nunca está garantizado. La lotería depende del factor suerte. Aunque algunas estrategias pueden ayudarte a tomar decisiones más informadas, los resultados son completamente aleatorios.",
    },
    {
      icon: Trophy,
      title: "¿Puedes Ganar Usando Predicciones?",
      text: "Sí, puedes ganar, pero también puedes perder. Las predicciones deben verse como una guía para mejorar tu estrategia, no como una promesa de éxito asegurado. Juega con responsabilidad y nunca apuestes más de lo que estés dispuesto a perder.",
    },
  ];

  return (
    <section className="py-16 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((it) => {
            const Icon = it.icon;
            return (
              <div key={it.title} className="np-card bg-white rounded-2xl shadow-md border border-blue-100 p-6">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#1d6cb1] to-[#2a83ce] flex items-center justify-center text-white mb-4">
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="font-bold text-lg text-[#0e4a7a] mb-2">{it.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{it.text}</p>
              </div>
            );
          })}
        </div>

        {/* Lotteries indicated */}
        <div className="mt-12 bg-white rounded-2xl shadow-md border border-blue-100 p-8">
          <div className="text-center mb-6">
            <h3 className="text-2xl font-extrabold text-[#0e4a7a]">Loterías Indicadas</h3>
            <p className="text-sm text-gray-600 mt-2">
              Estos números son recomendados para los siguientes sorteos del día.
            </p>
          </div>
          <div className="flex flex-wrap justify-center gap-3">
            {lotteries.map((l) => (
              <span
                key={l}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-50 text-[#0e4a7a] font-medium text-sm border border-blue-100 hover:bg-[#1d6cb1] hover:text-white transition cursor-pointer"
              >
                <CheckCircle2 className="w-4 h-4" />
                {l}
              </span>
            ))}
          </div>
        </div>

        {/* Responsible play */}
        <div className="mt-8 rounded-2xl bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 p-6 flex gap-4">
          <div className="w-12 h-12 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center flex-shrink-0">
            <ShieldAlert className="w-6 h-6" />
          </div>
          <div>
            <h4 className="font-bold text-amber-900">Juega de manera responsable</h4>
            <p className="text-sm text-amber-800/90 mt-1">
              Conforme a la <strong>Ley 29-06</strong>, te recordamos jugar con moderación. El juego de azar está prohibido para menores de 18 años. Las predicciones son orientativas y nunca garantizan una victoria.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
